<template>
  <div class="disease-info-wrapper">
    <div class="title">{{ title }}</div>
    <select-bar
      type="symptom"
      :show-error="showSymptomError"
      :show-tags="showSymptomTags"
      :tags="symptomTags"
      :title="nwVideo ? '症状' : '症状（最多可选5项）'"
      placeholder="请填写症状"
      error="请选择症状"
      :isCustomized="isCustomizedSymptom"
      @onFocus="focusSymptom('web-event-click-symptom')"
    />
    <select-bar
      is-illness
      type="diagnose"
      :show-error="showDiagnoseError"
      :show-tags="showDiagnoseTags"
      :tags="diagnoseTags"
      :title="nwVideo ? '已确诊疾病' : '已确诊疾病（最多可选5项）'"
      placeholder="请填写疾病诊断"
      error="请选择疾病诊断"
      :isCustomized="isCustomizedDiagnose"
      @onFocus="focusDiagnose('web-event-click-diagnosis')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import selectBar from './selectBar';

export default {
  name: 'diseaseInfo',
  props: {
    title: String, // 新版视频问诊
    showSymptomError: Boolean,
    showSymptomTags: {
      type: Array,
      default: () => []
    },
    symptomTags: {
      type: Array,
      default: () => []
    },
    showDiagnoseError: Boolean,
    showDiagnoseTags: {
      type: Array,
      default: () => []
    },
    diagnoseTags: {
      type: Array,
      default: () => []
    },
    isCustomizedSymptom: {
      type: Boolean,
      default: true
    },
    isCustomizedDiagnose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('nwVideo', ['nwVideo'])
  },
  components: {
    selectBar
  },
  methods: {
    focusSymptom() {},
    focusDiagnose() {}
  }
};
</script>

<style lang="scss" scoped>
.disease-info-wrapper {
  margin-bottom: 20px;
  width: 90%;

  .title {
    margin-bottom: 11px;
    color: #242424;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
